module.exports = require("iframe-resizer/js/iframeResizer.contentWindow");